import {Component} from '@angular/core';
import {Shared} from "../shared/shared";

@Component({
  selector: 'app-menu-tutor',
  templateUrl: 'menuTutor.html',
  styleUrls: ['menuTutor.scss']
})
export class MenuTutor {

  constructor(private shared: Shared) {}
}
